module.exports = __webpack_public_path__ + "media/images/digivent/facebook_icon-a34a318c6720b084fce5a51f83f4f816.svg";